// Vorschlag für den Kurznamen aus dem Mandantennamen:
// "Müller & Söhne GmbH" -> "mueller-soehne-gmbh" (gleiche Regeln wie die DB).
export function suggestSubdomain(name: string): string {
  return name
    .toLowerCase()
    .replace(/ä/g, "ae")
    .replace(/ö/g, "oe")
    .replace(/ü/g, "ue")
    .replace(/ß/g, "ss")
    .normalize("NFKD") // zerlegt z. B. "é" in "e" + Akzent …
    .replace(/[̀-ͯ]/g, "") // … und entfernt den Akzent
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 32)
    .replace(/-+$/, "");
}
